import PropTypes from 'prop-types';
import FJDragBox from '../../../../common/components/FJDragBox/FJDragBox';
import styles from './FJImageExtenderRight.module.less';
import FJImageExtenderCreationsContainer from '../container/FJImageExtenderCreationsContainer';
import classNames from 'classnames';
import FJHistoryPanelContainer from '../../../FJMainPreview/FJHistoryPanel/FJHistoryPanelContainer';
import FJCreationPanelContainer from '../../../FJMainPreview/FJCreationPanel/FJCreationPanelContainer';
import FJDisplayHeaderContainer from '../../../FJMainPreview/FJDisplayHeader/FJDisplayHeaderContainer';
import FJConstant from '../../../../constants/FJConstant';

const FJImageExtenderRight = props => {
    const { headerTabIndex, setIsDraggingFile, uploadImg, taskStatus } = props;

    return (
        <FJDragBox
            setIsDragging={setIsDraggingFile}
            disable={taskStatus !== FJConstant.DEFAULT}
            uploadFile={uploadImg}
            className={classNames(styles.app_right)}
        >
            <FJDisplayHeaderContainer />

            <FJImageExtenderCreationsContainer active={headerTabIndex === FJConstant.CREATIONS} />

            <FJCreationPanelContainer activeHeaderTabIndex={FJConstant.GENERATIONS} hideCompare={true} />

            <FJHistoryPanelContainer activeHeaderTabIndex={FJConstant.HISTORY} />
        </FJDragBox>
    );
};

FJImageExtenderRight.propTypes = {
    headerTabIndex: PropTypes.string,
    uploadImg: PropTypes.func,
    setIsDraggingFile: PropTypes.func,
    taskStatus: PropTypes.string,
};

export default FJImageExtenderRight;
